import { ATTRIBUTE_URL_ACTION, BACK_ACTION, CHART_DESIGNER_ACTION, CHART_VIEWER_ACTION, DELETE_ACTION, EDIT_ACTION, EXTERNAL_URL_ACTION, LINK_ACTION, LIST_DESIGNER_ACTION, NAVIGATE_ACTION, NEW_ACTION, REFRESH_ACTION, UNLINK_ACTION } from "./constants";

export const displayedTypes = ["Button", "Button Group"];

export function getAllowedActionTypes(componentType, pageType, useAsReference, usedActionTypes) {
    let allowedActionTypes = [];
    switch (componentType) {
        case "Calendar":
        case "Cards":
        case "Kanban":
            allowedActionTypes = getGroupComponentActionsType(useAsReference);
            break;
        case "Gantt Chart":
        case "Table":
            if (pageType === "Link Record") {
                allowedActionTypes = [LINK_ACTION, UNLINK_ACTION];
                break;
            }
            allowedActionTypes = getGroupComponentActionsType(useAsReference);
            break;
        case "Heading":
            switch (pageType) {
                case "Table":
                case "Cards":
                case "Kanban":
                case "Calendar":
                case "Gantt Chart":
                case "List":
                    allowedActionTypes = getHeadingComponentActionTypes(pageType, useAsReference);
                    break;
                case "Single Record":
                    allowedActionTypes = [NAVIGATE_ACTION, EXTERNAL_URL_ACTION, ATTRIBUTE_URL_ACTION, REFRESH_ACTION, BACK_ACTION, EDIT_ACTION, DELETE_ACTION];
                    break;
            }
            break
        default:
            allowedActionTypes = [];
            break;
    }
    const filteredActionTypes = allowedActionTypes.filter((actionType) => (
        !usedActionTypes.includes(actionType)
    ));
    return filteredActionTypes;
}

function getGroupComponentActionsType(useAsReference) {
    if (useAsReference) {
        return [NAVIGATE_ACTION, EXTERNAL_URL_ACTION, ATTRIBUTE_URL_ACTION, EDIT_ACTION, DELETE_ACTION, UNLINK_ACTION, LIST_DESIGNER_ACTION, CHART_DESIGNER_ACTION, CHART_VIEWER_ACTION];
    }
    return [NAVIGATE_ACTION, EXTERNAL_URL_ACTION, ATTRIBUTE_URL_ACTION, EDIT_ACTION, DELETE_ACTION, LIST_DESIGNER_ACTION, CHART_DESIGNER_ACTION, CHART_VIEWER_ACTION];
}

function getHeadingComponentActionTypes(pageType, useAsReference) {
    if (useAsReference) {
        return [EXTERNAL_URL_ACTION, NEW_ACTION, BACK_ACTION, REFRESH_ACTION, LINK_ACTION];
    }
    if (pageType === "Single Record") {
        return [NAVIGATE_ACTION, EXTERNAL_URL_ACTION, ATTRIBUTE_URL_ACTION, REFRESH_ACTION, BACK_ACTION, EDIT_ACTION, DELETE_ACTION];
    }
    return [NAVIGATE_ACTION, EXTERNAL_URL_ACTION, NEW_ACTION, LIST_DESIGNER_ACTION, CHART_DESIGNER_ACTION, CHART_VIEWER_ACTION, BACK_ACTION, REFRESH_ACTION];
}

export function getUsedActionTypes(actions) {
    const usedActionTypes = {};
    for (const action of actions) {
        usedActionTypes[action.actionType] = true;
        if (action.actions) {
            for (const childAction of action.actions) {
                usedActionTypes[childAction.actionType] = true;
            }
        }
    }

    // always allow navigate action
    delete usedActionTypes[NAVIGATE_ACTION];

    return Object.keys(usedActionTypes);
}

export function getShowAsOptions(actionType) {
    switch (actionType) {
        case "Navigate":
            return ["Inline"];
        case "Navigate to External URL":
        case "Navigate to Attribute URL":
            return ["Inline", "New Tab", "New Window"];
        case "Edit":
        case "New":
            return ["Popup"];
        default:
            return [];
    }
};

export function isUrlValid(url) {
    return url.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?(\/.*)?$/);
}

export function getTargetPageOptionsForActionType(allPages, actionType, componentType, isReferencePage) {
    switch (actionType) {
        case "New":
            return allPages.filter((page) => page.subPageType === "New Record");
        case "Edit":
            return allPages.filter((page) => page.subPageType === "Edit Record");
        case "Link":
            return allPages.filter((page) => page.subPageType === "Link Record");
        case "Navigate":
            if (
                componentType === "Heading" && isReferencePage
            ) {
                return allPages.filter(
                    (page) =>
                        page.subPageType !== "New Record" &&
                        page.subPageType !== "Edit Record" &&
                        page.subPageType !== "Link Record" &&
                        page.subPageType !== "Single Record" &&
                        page.useAsReference === "false"
                );
            }
            if (
                componentType === "Cards" || componentType === "Table"
            ) {
                return allPages.filter(
                    (page) => page.subPageType === "Single Record"
                );
            }
            if (componentType === "Heading" && !isReferencePage) {
                return allPages.filter(
                    (page) =>
                        !page.useAsReference &&
                        page.subPageType !== "New Record" &&
                        page.subPageType !== "Edit Record" &&
                        page.subPageType !== "Link Record" &&
                        page.subPageType !== "Single Record"
                );
            }
            return allPages.filter(
                (page) =>
                    !page.useAsReference &&
                    page.subPageType !== "New Record" &&
                    page.subPageType !== "Edit Record" &&
                    page.subPageType !== "Link Record"
            );
        case "Navigate to External URL":
        case "Navigate to Attribute URL":
        default:
            return [];
    }
}